import { configureStore } from "@reduxjs/toolkit";
import authSlice from "./slices/auth-slice";
import sidebarSlice from "./slices/sidebar-slice";

export default configureStore({
    reducer:{
        auth: authSlice,
        left: sidebarSlice,
    }
})